<template>
  <!-- <div style="position: relative; height:600px">
    <div v-if="loading" class="loading-div">
      <Button loading shape="circle" type="primary"></Button>
      <div>loading...</div>
    </div> -->
	<div>
		<cTable
		  ref="charges_type"
		  :fields="charges_type_fields"
		  :config="charges_type_config"
		  :footer="charges_type_footer"
		>
		</cTable>
		<cTable
		  ref="remark"
		  :fields="remark_fields"
		  :config="remark_config"
		  :footer="remark_footer"
		>
		</cTable>
		<div style="margin-bottom:10px">
			{{$tz('客户报价规则')}}：<Select v-model="rule_id" @on-change="handleRule" style="width:200px;">
					<Option v-for="item in rules" :value="item.value" :key="item.value">{{ item.label }}</Option>
			</Select>
		</div>
		<cTable
		  ref="table"
		  :fields="fields"
		  :methods="methods"
		  :config="config"
		  :footer="footer"
		>
		</cTable>
	</div>
  
  <!-- </div> -->
</template>

<script>
import {
  detail,
	conf,
	getRemark,
	showQuote
} from "@/api/order/miscellaneousQuotation";
import {apis} from '@/api/priceRule/otherQuotation.js'
import { getConfig } from "@/api/tracker/cost_page";
import { getExpense } from "@/api/finance/expense";
import cTable from "@/base/common/index";
import { Mul } from "@/libs/tools";
import { getCurrency } from "@/api/finance/currency";

import numFun from "@/utils/numFun";
import {
  getItem,
	} from "@/api/double/list";
export default {
  components: {
    cTable,
  },
  props: {
    rows: {
      type: Object,
    },
		height:{
			type:Number,
			default:400
		},
		read:{
			type:Boolean,
			default:false,
		},
		branch:{
			type:Boolean,
			default:false,
		},
		hq:{
			type:Boolean,
			default:false,
		}
  },
	methods:{
		handleRule(){
			this.$refs['table'].getList()
		}
	},
  data() {
    let that = this;
    return {
			rule_id:'',
			rules:[],
			charges_type_fields:[],
			charges_type_config:{
				height:'110',
				slot:'div',
				resize: false,
			},
			charges_type_footer:{
				show:()=>false
			},
			remark_fields:[
				{
					name:()=>this.$t("Expense Item"),
					key:"expense_item",
					minWidth:130,
				},
				{
					name:()=>this.$t("operate1"),
					key:"operator_name",
					minWidth:130,
				},
				{
					name:()=>this.$t("warehouseName2"),
					key:"warehouse",
					minWidth:130,
				},
				{
					name:()=>this.$t("quantity1"),
					key:"charges_value",
					minWidth:130,
				},
				{
					name:()=>this.$t("billing_unit"),
					key:"charges_unit",
					minWidth:130,
				},
				{
					name:()=>this.$t("Remarks"),
					key:"remarks",
					minWidth:130,
				},
				{
					name:()=>this.$t("operation time"),
					key:"create_time",
					minWidth:130,
				}
			],
			remark_config:{
				height:'200',
				slot:'div',
				resize: false,
			},
			remark_footer:{
				show:()=>false
			},
      loading: false,
      list: [],
      expenseList: [],
      currencyList: [],
      bubbleList: [],
      searchData: {},
      unitList: [],
      actual_weight: 0,
      volume_weight: 0,
      totalAmount: [],
			footer:{
				show:()=>false
			},
      methods: {
        list: (p) => {
					p.size = 999
					if(this.read){
						return showQuote({master_id:this.rows.master_id,size:999,branch:this.branch})
					}
					if(this.rule_id)p.rule_id = this.rule_id;
          p["id"] = this.rows.id;
          return detail(p);
        },
      },
      config: {
        height: this.height,
        slot: "div",
        resize: false,
        showOverflow: false,
        // showFooter: true,
        // footerCellClassName: "col-red",
        // footerMethod: ({ columns, data }) => {
        //   const sums = [];
        //   columns.forEach(column => {
        //     let sumCell = null;
        //     switch (column.property) {
        //       case "operator_name":
        //         sumCell = this.$t("summary") + this.$t("statistics");
        //         break;
        //       case "amount":
        //         sumCell = sumCell = numFun.sumNumFun(data, column.property, 2);
        //         break;
        //       default:
        //         sumCell = "-";
        //         break;
        //     }
        //     sums.push(sumCell);
        //   });
        //   // 返回一个二维数组的表尾合计
        //   return [sums];
        // }
      },
      fields: [
        {
          name: () => this.$t("operate"),
          key: "operator_name",
          // component: "Input",
          placeholder() {
            return this.$t("operate");
          },
          disabled: true,
					width: 100,
        },
        {
          name: () => this.$t("operate") + this.$t("time"),
          key: "create_time",
          // component: "Input",
          placeholder() {
            return this.$t("operate") + this.$t("time");
          },
          width: 150,
        },
        {
          name: () => this.$t("Expense Item"),
          key: "expense_item_id",
          component: "Select",
          placeholder() {
            return ' ';
          },
					bind:{
						transfer:true,
					},
					disabled: ({row})=>{
						return !!row.id || this.read
					},
          options: [],
					minWidth: 200,
        },
        {
          name: () => this.$t("calculation") + this.$t("currency_t"),
          key: "currency",
          component: "Select",
					disabled:()=>this.read,
          placeholder:()=> {
            return this.read?'': (
              this.$t("select") + this.$t("calculation") + this.$t("currency_t")
            );
          },
					config:{
						label:'code',
						value:'code'
					},
          options: [],
					bind:{
						transfer:true,
					},
					minWidth:120,
        },
				{
				  name: () => this.$t("Billing") + this.$t("number"),
				  key: "charges_type",
				  component: "Select",
					disabled:()=>this.read,
					bind:{
						transfer:true,
					},
				  placeholder:()=> {
				    return this.read?'': (
				      this.$t("select") + this.$t("Billing") + this.$t("number")
				    );
				  },
					show:()=>!this.hq,
					minWidth:120,
					// config:{
					// 	label:'code',
					// 	value:'code'
					// },
				  options: [],
					methods: {
					  "on-change"({ row, field,value }) {
							if(!value)return 
							row.charge = field.options.find(t=>t.value == value).charge
					    row.total_amount = Mul(row.charge || 0, row.price);
					  },
					},
				},
        
        {
          name: () => this.$t("doublePrice"),
          key: "price",
          component: "Input",
					disabled:()=>this.read,
          bind: {
            type: "number",
          },
          placeholder:()=> {
            return this.read?'': (this.$t("enter") + this.$t("doublePrice"));
          },
					default:0,
          methods: {
            "on-change"({ row }) {
              row.total_amount = Mul(row.charge || 0, row.price);
            },
          },
					minWidth:120,
        },
				{
				  name: () => this.$t("doubleAmount"),
				  key: "total_amount",
				  component: "Input",
					disabled:()=>this.read,
					disabled:true,
				  bind: {
				    type: "number",
				  },
				  placeholder:()=> {
				    return this.read?'': (this.$t("enter") + this.$t("doubleAmount"));
				  },
					minWidth:120,
				},
        {
          name: () => this.$t("Remarks"),
          key: "remarks",
          component: "Input",
					disabled:()=>this.read,
					bind:{
						type: "textarea",
						rows: 2,
					},
          placeholder:()=> {
            return this.read?'': (this.$t("enter") + this.$t("Remarks"));
          },
					minWidth:120,
        },
				{
				  type: "btns",
				  width: 160,
				  name: () => this.$t("operation"),
				  fixed: "right",
				  list: [
				    {
				      name: () => this.$t("add"),
				      type: "add",
				      fnName: "add",
							show:()=>!this.read,
				      bind: {
				        type: "warning",
				      },
				      icon: "md-add",
				    },
				    {
				      name: () => this.$t("delete"),
				      type: "delete",
				      fnName: "delete",
				      icon: "md-trash",
							show:({row})=>{
								return !row.id && !this.read
							},
				    },
				  ],
				  methods: {
				    add({ row,rowIndex }) {
							this.list.splice(rowIndex,0,{
									"expense_item_id": '',
									"charges_type": 0,
									"charges_value": "",
									"price": "",
									"total_amount": "",
									"currency": "",
									"remarks": ""
							})
				    },
				    delete({ row,rowIndex }) {
							this.list.splice(rowIndex,1)
							if(!this.list.length)this.list.push({
									"expense_item_id": '',
									"charges_type": 0,
									"charges_value": "",
									"price": "",
									"total_amount": "",
									"currency": "",
									"remarks": ""
							})
				    },
				  },
				}
      ],
    };
  },
  async mounted() {
		this.rows.client_id && apis.select({client_id:this.rows.client_id}).then(res=>{
			if(res.data.status){
				this.rules = res.data.payload
			}
		})
    this.loading = true;
    this.expenseList = (await getItem()).data.payload;
    let currency = (await getCurrency()).data.payload.rows;
    let charges_type = []
		if(!this.hq){
			charges_type = (await conf({id:this.rows.id})).data.payload.rows;
		}
    let remark = (await getRemark({ids:this.hq?this.rows.master_id:[this.rows.id]})).data.payload.rows;
    // let bubbleList = (await getIncomeWeight()).data.payload;
    this.fields.forEach((el) => {
      if (el.key == "expense_item_id") el.options = this.expenseList;
      if (el.key == "currency") el.options = currency;
      if (el.key == "charges_type") el.options = charges_type;
    });
		charges_type = charges_type.reduce((a,b)=>{
			a[b.label] = b.charge
			this.charges_type_fields.push({
				name:b.label,
				key:b.label,
				minWidth:120,
			})
			return a
		},{})
    this.$refs['charges_type'] && (this.$refs['charges_type'].list = [charges_type])
    this.$refs['remark'] && (this.$refs['remark'].list = remark)
    this.loading = false;
  },
};
</script>
